"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  scheme: 'solarized',
  author: 'ethan schoonover (http://ethanschoonover.com/solarized)',
  base00: '#002b36',
  base01: '#073642',
  base02: '#586e75',
  base03: '#657b83',
  base04: '#839496',
  base05: '#93a1a1',
  base06: '#eee8d5',
  base07: '#fdf6e3',
  base08: '#dc322f',
  base09: '#cb4b16',
  base0A: '#b58900',
  base0B: '#859900',
  base0C: '#2aa198',
  base0D: '#268bd2',
  base0E: '#6c71c4',
  base0F: '#d33682'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90aGVtZXMvc29sYXJpemVkLnRzIl0sIm5hbWVzIjpbInNjaGVtZSIsImF1dGhvciIsImJhc2UwMCIsImJhc2UwMSIsImJhc2UwMiIsImJhc2UwMyIsImJhc2UwNCIsImJhc2UwNSIsImJhc2UwNiIsImJhc2UwNyIsImJhc2UwOCIsImJhc2UwOSIsImJhc2UwQSIsImJhc2UwQiIsImJhc2UwQyIsImJhc2UwRCIsImJhc2UwRSIsImJhc2UwRiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O2VBQWU7QUFDYkEsRUFBQUEsTUFBTSxFQUFFLFdBREs7QUFFYkMsRUFBQUEsTUFBTSxFQUFFLHlEQUZLO0FBR2JDLEVBQUFBLE1BQU0sRUFBRSxTQUhLO0FBSWJDLEVBQUFBLE1BQU0sRUFBRSxTQUpLO0FBS2JDLEVBQUFBLE1BQU0sRUFBRSxTQUxLO0FBTWJDLEVBQUFBLE1BQU0sRUFBRSxTQU5LO0FBT2JDLEVBQUFBLE1BQU0sRUFBRSxTQVBLO0FBUWJDLEVBQUFBLE1BQU0sRUFBRSxTQVJLO0FBU2JDLEVBQUFBLE1BQU0sRUFBRSxTQVRLO0FBVWJDLEVBQUFBLE1BQU0sRUFBRSxTQVZLO0FBV2JDLEVBQUFBLE1BQU0sRUFBRSxTQVhLO0FBWWJDLEVBQUFBLE1BQU0sRUFBRSxTQVpLO0FBYWJDLEVBQUFBLE1BQU0sRUFBRSxTQWJLO0FBY2JDLEVBQUFBLE1BQU0sRUFBRSxTQWRLO0FBZWJDLEVBQUFBLE1BQU0sRUFBRSxTQWZLO0FBZ0JiQyxFQUFBQSxNQUFNLEVBQUUsU0FoQks7QUFpQmJDLEVBQUFBLE1BQU0sRUFBRSxTQWpCSztBQWtCYkMsRUFBQUEsTUFBTSxFQUFFO0FBbEJLLEMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gIHNjaGVtZTogJ3NvbGFyaXplZCcsXG4gIGF1dGhvcjogJ2V0aGFuIHNjaG9vbm92ZXIgKGh0dHA6Ly9ldGhhbnNjaG9vbm92ZXIuY29tL3NvbGFyaXplZCknLFxuICBiYXNlMDA6ICcjMDAyYjM2JyxcbiAgYmFzZTAxOiAnIzA3MzY0MicsXG4gIGJhc2UwMjogJyM1ODZlNzUnLFxuICBiYXNlMDM6ICcjNjU3YjgzJyxcbiAgYmFzZTA0OiAnIzgzOTQ5NicsXG4gIGJhc2UwNTogJyM5M2ExYTEnLFxuICBiYXNlMDY6ICcjZWVlOGQ1JyxcbiAgYmFzZTA3OiAnI2ZkZjZlMycsXG4gIGJhc2UwODogJyNkYzMyMmYnLFxuICBiYXNlMDk6ICcjY2I0YjE2JyxcbiAgYmFzZTBBOiAnI2I1ODkwMCcsXG4gIGJhc2UwQjogJyM4NTk5MDAnLFxuICBiYXNlMEM6ICcjMmFhMTk4JyxcbiAgYmFzZTBEOiAnIzI2OGJkMicsXG4gIGJhc2UwRTogJyM2YzcxYzQnLFxuICBiYXNlMEY6ICcjZDMzNjgyJyxcbn07XG4iXX0=